/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    size: { type: 'variant', values: [ 'mini' ] },
    style: {
      description: 'Configure `style` variant for `Progress`',
      type: 'variant',
      values: [ 'inverse' ]
    }
  },
  rules: [
    { if: { size: 'mini' }, tokens: { height: 8 } },
    {
      if: { style: 'inverse' },
      tokens: {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderColor: 'rgba(255, 255, 255, 0.4)',
        shadow: {
          blur: 2,
          color: 'rgba(0, 0, 0, 0.1)',
          inset: true,
          offsetX: 0,
          offsetY: 2,
          spread: 0
        }
      }
    }
  ],
  tokens: {
    backgroundColor: '#fafafa',
    borderColor: '#666666',
    borderRadius: 12,
    borderWidth: 1,
    height: 16,
    shadow: {
      blur: 2,
      color: 'rgba(0, 0, 0, 0.1)',
      inset: true,
      offsetX: 0,
      offsetY: 2,
      spread: 0
    }
  }
}
export default theme
